import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import Impressum from './Impressum';
import Datenschutz from './Datenschutz';
import { BrowserRouter, Route, Routes } from "react-router-dom";

import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
<Routes>
    <Route path="/"
              element={ <App/>}/>
        <Route path="/impressum"
              element={ <Impressum/>}/>
              
                <Route path="/datenschutz"
              element={ <Datenschutz/>}/>
</Routes>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
